import { generatePath } from 'react-router-dom';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';

const ROOT_PATH = '/';
const STAKING_PATH = `${ROOT_PATH}/staking`;
const UNSTAKING_PATH = `${ROOT_PATH}/unstaking`;

export const dashboardRoutesConfig = createRouteConfig(
  {
    dashboard: {
      path: ROOT_PATH,
      generatePath: () => generatePath(ROOT_PATH),
    },
    staking: {
      path: STAKING_PATH,
      generatePath: () => generatePath(STAKING_PATH),
    },
    unstaking: {
      path: UNSTAKING_PATH,
      generatePath: () => generatePath(UNSTAKING_PATH),
    },
  },
  ROOT_PATH,
);
